import { render, staticRenderFns } from "./Displays.vue?vue&type=template&id=2542c04e&"
import script from "./Displays.vue?vue&type=script&lang=js&"
export * from "./Displays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports